import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Row } from 'antd';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import { DIR_RTL } from 'constants/ThemeConstant';
import useQuery from 'hooks/useQuery';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { changePromotionsQuantity, getCategoryProducts, getStoreTiming, updateDataState } from 'redux/actions';
import { setLocalStorageCart } from 'utils/cart';
import GridProduct from './GridProduct';
import CardSkeleton from "../../../search/CardSkeleton";
import { isOpenByTime } from 'utils/estimated';

function GridProducts() {
    const skeleton = [0, 1, 2, 3, 4, 5];

    const { 
        fetchedData: { categoryProducts, storeData, timings }, 
        theme: { locale, direction }, 
        cartData: { cartQuantity, homePromotion } 
    } = useSelector(state => state)
    const [subTotal, setSubTotal] = useState(0)
    const [promotions, setPromotions] = useState(0)

    const currency = storeData?.currency?.name ?? 'KWD'

    const params = useParams();
    const query = useQuery();
    const dispatch = useDispatch();

    useEffect(() => {
        //scroll to top
        window.scrollTo({top:0, behavior: 'auto'});

        // get timings
        timings?.length<1 && dispatch(getStoreTiming());

        //get products
        dispatch(getCategoryProducts(params.id+(localStorage.getItem('selected-mode')==='pickup'? ('?branchId='+JSON.parse(localStorage.getItem('selected-branch')).id) :'')))

        //check if voucher is applied
        if (localStorage.getItem('applied-voucher')){
            dispatch(changePromotionsQuantity(JSON.parse(localStorage.getItem('applied-voucher'))))
        }else{
            dispatch(changePromotionsQuantity({}))
        }

        setSubTotal(setLocalStorageCart()?.reduce((acc, cur)=>acc+(cur.itemTotal), 0))
        setPromotions(setLocalStorageCart()?.reduce((acc, cur) => {
            return acc + (cur.product.promotions?.[0]?.discountType === 'AMOUNT' ? cur.product.promotions[0].amount :
            cur.product.promotions?.[0]?.discountType === 'PERCENTAGE' ? cur.price * 100 / ( 100 - cur.product.promotions?.[0].amount) - cur.price : 0) * cur.quantity
        }, 0))

        // clear categoryProducts
        return () => {
            dispatch(updateDataState({categoryProducts: {}}))
        }
    }, [])

    useEffect(()=>{
        const sumOfItemsPrice = setLocalStorageCart()?.reduce((acc, cur)=>acc+(cur.itemTotal), 0)
        if (homePromotion?.minimumPurchase <= sumOfItemsPrice){
            if (homePromotion?.discountType === 'AMOUNT'){
                setSubTotal(sumOfItemsPrice-homePromotion.amount )
                setPromotions(homePromotion.amount)
            }else{
                setSubTotal(sumOfItemsPrice-(sumOfItemsPrice*homePromotion.amount/100))
                setPromotions(sumOfItemsPrice*homePromotion.amount/100)
            }
        }else{
            setSubTotal(sumOfItemsPrice)
            setPromotions(setLocalStorageCart()?.reduce((acc, cur) => {
                return acc + (cur.product.promotions?.[0]?.discountType === 'AMOUNT' ? cur.product.promotions?.[0].amount :
                cur.product.promotions?.[0]?.discountType === 'PERCENTAGE' ? cur.price * 100 / ( 100 - cur.product.promotions[0].amount) - cur.price : 0) * cur.quantity
            }, 0))
        }
    }, [homePromotion, cartQuantity])

    return (
        <div style={{ overflowX: 'hidden', height: '100vh', position: 'relative'}}>
            <div className='relative d-flex align-items-center p-3'>
                <div onClick={() => {
                    window.history.back();
                }} style={{ position: 'absolute' }}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{ fontSize: '24px', cursor: 'pointer', color: 'black' }} />
                </div>
                <div className='text-center w-100' style={{ fontSize: "17px", color: '#000', fontWeight: '600' }}>
                    {locale === 'en' ? query.get('nameEng') : query.get('nameAr')}
                </div>
            </div>
            <Divider className='my-0'/>
            {categoryProducts?.content ?
                <div className="grid-child-product" style={{height: cartQuantity > 0 ? '77vh' : '91vh'}}>
                    <Row gutter={24} justify="" className='p-3'>
                        {categoryProducts?.content?.map(product => <GridProduct key={product.id} product={product} locale={locale} />)}
                    </Row>
                </div>
                :
                <Row gutter={8} className="mx-3 my-4">
                    {skeleton.map(item => <Col lg={12} md={6} sm={8} xs={12} key={item}>
                        <CardSkeleton/>
                    </Col>)}
                </Row>
            }
            {cartQuantity > 0 && storeData?.enableDelivery && <div className="menu-bottom menu-bottom-mobile">
                <Button className={`w-100 reviewButton primaryColor`} style={{height:  promotions === 0 ? '48px' : 'auto'}}>
                    <Link to={APP_PREFIX_PATH + '/review-cart'}>
                        <div className={`w-100 d-flex justify-content-between align-items-center`}>
                            <div className="font-16 ml-1 mr-2 d-flex"><div className='reviewButtonNum primaryDarkColor'>{cartQuantity}</div> Review Order</div>
                            <div>
                                {currency} {subTotal.toFixed(3)} <br/>
                                { promotions !== 0 ? <div style={{textDecoration: 'line-through', fontSize: '13px', filter: 'brightness(40%)'}}>
                                    {currency} {(subTotal + promotions).toFixed(3)}
                                </div> : ""}
                            </div>
                        </div>
                    </Link>
                </Button>
            </div>}
            {(!storeData?.enableDelivery || !isOpenByTime(timings)) && <div className="menu-bottom menu-bottom-mobile">
                <Button disabled className={`w-100 reviewButton primaryColor`} style={{height: '48px' }}>
                    <div className={`w-100 d-flex justify-content-center align-items-center`}>
                        Sorry! we're temporarily closed
                    </div>
                </Button>
            </div>}
        </div>
    )
}

export default GridProducts